import React from 'react'
import './line-component.scss'

const Line = () => {
  return <div className='line'></div>
}
export { Line }
